// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1tGng","disabled":"FileBtn_disabled__2y0_g","warn":"FileBtn_warn__1-TpP","fade":"FileBtn_fade__3dqcR"};